module.exports = __webpack_public_path__ + "img/canceled-bg.0f20edb5.png";